<template>
  <section>
    <v-toolbar class="green header" fixed dark height="90">
      <admin-header/>
    </v-toolbar>

    <v-container class="main-container">
      <v-layout row>
        <v-flex md12>
          <main class="content">
            <slot name="content"/>
            <div class="">
              <slot name="list" />
            </div>
          </main>
        </v-flex>
      </v-layout>
    </v-container>
    <contact-component/>
  </section>
</template>

<script>

import AdminHeader from '@/components/base/AdminHeader';
import ContactComponent from '@/components/ContactComponent';

export default {
  name: 'AdminLayout',
  components: {
    AdminHeader,
    ContactComponent,
  },
};
</script>

<style lang="scss" scoped>
  .main-container{
    margin-top: 90px !important;
  }
  .header{
    z-index: 100;
  }
</style>
